import { render } from "./ReceptionTypes.vue?vue&type=template&id=662343ee"
import script from "./ReceptionTypes.vue?vue&type=script&lang=js"
export * from "./ReceptionTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__